/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'email_letter': {
    width: 20,
    height: 17,
    viewBox: '0 0 20 17',
    data: '<path pid="0" d="M17.84 0c1.182 0 2.139.992 2.139 2.216l.002.694a.764.764 0 010 .344l-.002 10.78c0 1.224-.957 2.216-2.138 2.216H2.159c-1.18 0-2.138-.992-2.138-2.216L.02 3.252a.764.764 0 010-.344l.001-.692C.021.992.978 0 2.159 0h15.682zM1.447 4.398v9.636c0 .408.32.739.713.739h15.682c.393 0 .712-.331.712-.739V4.4l-8.186 5.098a.694.694 0 01-.734-.001L1.446 4.398zm16.395-2.92H2.159a.726.726 0 00-.712.738l-.001.459L10 8.002l8.553-5.326v-.46a.726.726 0 00-.712-.739z" _fill="#213F6B" fill-rule="nonzero"/>'
  }
})
